/**
 * Small API client — POSTs to the ZenMe backend.
 * Uses REACT_APP_BACKEND_URL + /api/... path.
 * All 4 form functions return a `SubmitResult` shape.
 */

const BASE = process.env.REACT_APP_BACKEND_URL;

class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.name = "ApiError";
    this.status = status;
  }
}

const post = async (path, body) => {
  if (!BASE) {
    throw new ApiError("Backend URL not configured.", 0);
  }
  let response;
  try {
    response = await fetch(`${BASE}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  } catch (err) {
    throw new ApiError("Network error. Please try again.", 0);
  }

  if (response.status === 429) {
    throw new ApiError(
      "Please slow down and try again in a few minutes.",
      429,
    );
  }
  if (response.status === 422) {
    throw new ApiError(
      "Please check your entries and try again.",
      422,
    );
  }
  if (!response.ok) {
    throw new ApiError(
      "Something went wrong. Please try again in a moment.",
      response.status,
    );
  }
  return response.json();
};

export const submitMerchantWaitlist = (payload) =>
  post("/api/waitlist/merchant", payload);

export const submitMarketplaceWaitlist = (payload) =>
  post("/api/waitlist/marketplace", payload);

export const submitPartnerApplication = (payload) =>
  post("/api/partners", payload);

export const submitContact = (payload) => post("/api/contact", payload);

/* ---------- Admin ---------- */

const adminGet = async (path, token) => {
  if (!BASE) throw new ApiError("Backend URL not configured.", 0);
  const response = await fetch(`${BASE}${path}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (response.status === 401 || response.status === 403) {
    throw new ApiError("Unauthorized", response.status);
  }
  if (!response.ok) {
    throw new ApiError("Request failed", response.status);
  }
  return response.json();
};

export const adminApi = {
  overview: (token) => adminGet("/api/admin/overview", token),
  attribution: (token) => adminGet("/api/admin/attribution", token),
  list: (token, kind, limit = 100, skip = 0) =>
    adminGet(
      `/api/admin/submissions/${kind}?limit=${limit}&skip=${skip}`,
      token,
    ),
};

export { ApiError };
